import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageCroppedEvent, ImageCropperComponent, ImageTransform, LoadedImage } from 'ngx-image-cropper';

@Component({
    selector: 'image-crop-modal',
    templateUrl: './image-crop-modal.component.html',
    styleUrls: ['./image-crop-modal.component.scss'],
    standalone: true,
    imports: [ImageCropperComponent]
})
export class ImageCropModalComponent {
    @Input() imageBase64: string = '';

    public croppedBase64: string = '';
    public transform: ImageTransform = {};
    private rotation = 0;

    constructor(public modal: NgbActiveModal) {}

    imageCropped(event: ImageCroppedEvent) {
        this.croppedBase64 = event.base64 || '';
    }

    imageLoaded(_image: LoadedImage) {}

    cropperReady() {}

    loadImageFailed() {}

    rotateLeft() {
        this.rotation = (this.rotation - 90 + 360) % 360;
        this.transform = { ...this.transform, rotate: this.rotation };
    }

    rotateRight() {
        this.rotation = (this.rotation + 90) % 360;
        this.transform = { ...this.transform, rotate: this.rotation };
    }

    flipHorizontal() {
        this.transform = { ...this.transform, flipH: !this.transform.flipH };
    }

    flipVertical() {
        this.transform = { ...this.transform, flipV: !this.transform.flipV };
    }

    apply() {
        this.modal.close(this.croppedBase64);
    }

    cancel() {
        this.modal.dismiss();
    }
}
